import React from 'react';

import { DwhSriCategory } from '@ndvr/market-data-api';

import { Checkbox } from '@/components/ui/checkbox';

interface SelectionTabProps {
    category: DwhSriCategory;
    selectedSubCategories: string[];
    onSelectionChange: (selected: string[]) => void;
}

export const SelectionTab = ({ category, selectedSubCategories, onSelectionChange }: SelectionTabProps) => {
    const allSubCategoryIds = category.subCategories?.map((sub) => sub.sriSubCategoryId) || [];
    const allSelected =
        allSubCategoryIds.length > 0 && allSubCategoryIds.every((id) => selectedSubCategories.includes(id));

    const handleSubCategoryChange = (subCategoryId: string, checked: boolean) => {
        if (checked) {
            onSelectionChange([...selectedSubCategories, subCategoryId]);
        } else {
            onSelectionChange(selectedSubCategories.filter((id) => id !== subCategoryId));
        }
    };

    const handleAllCategoriesChange = (checked: boolean) => {
        if (checked) {
            onSelectionChange(allSubCategoryIds);
        } else {
            onSelectionChange([]);
        }
    };

    return (
        <div className="mt-4 space-y-3">
            <div className="border-border flex items-center space-x-3 border-b pb-3">
                <Checkbox
                    id="all-categories"
                    checked={allSelected}
                    onCheckedChange={(checked) => handleAllCategoriesChange(checked === true)}
                />
                <label
                    htmlFor="all-categories"
                    className="text-sm leading-none font-semibold peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                    All Categories
                </label>
            </div>

            {category.subCategories?.map((subCategory) => (
                <div key={subCategory.sriSubCategoryId} className="flex items-center space-x-3">
                    <Checkbox
                        id={subCategory.sriSubCategoryId}
                        checked={selectedSubCategories.includes(subCategory.sriSubCategoryId)}
                        onCheckedChange={(checked) =>
                            handleSubCategoryChange(subCategory.sriSubCategoryId, checked === true)
                        }
                    />
                    <label
                        htmlFor={subCategory.sriSubCategoryId}
                        className="text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                        {subCategory.sriSubCategoryLabel}
                    </label>
                </div>
            ))}
        </div>
    );
};
